<div class="payment-icons">
  <GooglePay />
  <Klarna />
  <MasterCard />
  <ApplePay />
</div>
